import { useEffect, useState } from 'react';
import countryList from "../data/country.json";

const useCountriesList = () => {

    const [countriesOpt, setCountriesOpt] = useState();

    // retrieve countries list from json
    useEffect(() => {
        let countries: any = [];
        countryList.map(country => {
            countries.push({ value: country.Code, label: country.Name });
        });
        countries.sort((a, b) => a.label.localeCompare(b.label));
        setCountriesOpt(countries);
    }, []);


    return countriesOpt || [];
}

export default useCountriesList;